"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requireOptionalOnDeviceClientDependency = exports.requireOptionalClientDependency = void 0;
const client_core_1 = require("@statsig/client-core");
const NoopEvaluationsClient_1 = require("./NoopEvaluationsClient");
function requireOptionalClientDependency(sdkKey, initialUser, statsigOptions) {
    let client;
    try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-var-requires
        const mod = require('@statsig/js-client');
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        client = new mod.StatsigClient(sdkKey, initialUser, statsigOptions);
    }
    catch (error) {
        client = NoopEvaluationsClient_1.NoopEvaluationsClient;
        client_core_1.Log.error('Failed to load StatsigClient. Do you have @statsig/js-client installed?');
    }
    return client;
}
exports.requireOptionalClientDependency = requireOptionalClientDependency;
function requireOptionalOnDeviceClientDependency(sdkKey, statsigOptions) {
    let client;
    try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-var-requires
        const mod = require('@statsig/js-on-device-eval-client');
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        client = new mod.StatsigOnDeviceEvalClient(sdkKey, statsigOptions);
    }
    catch (error) {
        client = NoopEvaluationsClient_1.NoopEvaluationsClient;
        client_core_1.Log.error('Failed to load StatsigClient. Do you have @statsig/js-on-device-eval-client installed?');
    }
    return client;
}
exports.requireOptionalOnDeviceClientDependency = requireOptionalOnDeviceClientDependency;
